import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { selectsubscriptionsQueryItems } from '../../../../../redux/subscriptions/selector';
import { selectprogramsListItems, selectprogramsQueryItems } from '../../../../../redux/programs/selector';
import { subscriptions } from '../../../../../redux/subscriptions/action';
import { programs } from '../../../../../redux/programs/action';
import PageLoader from '../../../../../components/PageLoader';
import UpgradeSubscriptionComponent from '../components/upgrade-subscription/upgrade-subscription.component';


const UpgradeSubscription = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
const {id, tenantId} = useParams()

  const programItems = useSelector(selectprogramsListItems);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [showConfirmationModal, setShowConfirmationModal] = useState<boolean>(false);

  const [selectedSubscriptions, setSelectedSubscriptions] = useState<any>({
    Email: '',
    PhoneNumber: '',
    Name: '',
    Description: '',
    ownerType: 'DBaasProgramPolicy',
    Amount: 0,
    Validity: '',
  });


  const handleInnerFormChange = (event: any, field: string) => {
  
      setSelectedSubscriptions({ ...selectedSubscriptions, [field]: event });
    
  };

  useEffect(() => {
    dispatch(
      programs.list({
        url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/programs/list`,
        entity: 'programs',
        jsonData: {},
      })
    ).then(() => {
      if (Number(id) > 0) {
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    });
  }, []);


  const handleFormSubmit = (event: any) => {
    event.preventDefault();
    setShowConfirmationModal(true); // Show confirmation modal before submitting
  };

  const proceedWithSubmit = async () => {
    setShowConfirmationModal(false); // Hide the modal

    const subscriptionData = {
       "OwnerType": "DBaasProgram",
       "ExistingOwnerId": Number(id),
        "NewOwnerId": selectedSubscriptions?.OwnerId,
        "TenantId": Number(tenantId),
          "EnableAsNew": false
    };

    if (Number(id) > 0) {
      await dispatch(subscriptions.resetAction({ actionType: 'create' }));
      await dispatch(
        subscriptions.create({
          url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/platform-management/dbaas/subscriptions/upgrade`,
          entity: 'subscriptions',
          jsonData: {
            "Context":{},
            Records: [subscriptionData],
          },
        })
      ).then(() => {
        back();
      });
    }
  };

  const back = () => {
    navigate('/management/dbaas/subscriptions');
  };

  return (
    <>
      {isLoading ? (
        <PageLoader />
      ) : (
        <>
          <UpgradeSubscriptionComponent
            handleInnerFormChange={handleInnerFormChange}
            selectedSubscriptions={selectedSubscriptions}
            back={back}
            id={Number(id)}
            handleFormSubmit={handleFormSubmit}
            programs={programItems?.result?.items}
          />
          {showConfirmationModal && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
              <div className="bg-white p-6 rounded shadow">
               
                <p>Are you sure Do you want to Upgrade the subscription?</p>
                <div className="mt-4 flex justify-end space-x-2">
                  <button
                    onClick={() => setShowConfirmationModal(false)}
                    className="px-4 py-2 bg-gray-500 text-white rounded"
                  >
                    No
                  </button>
                  <button
                    onClick={proceedWithSubmit}
                    className="px-4 py-2 bg-blue-600 text-white rounded"
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default UpgradeSubscription;
